<template>
    <div class="mb-5 mt-2">
        <nuxt-link class="inline-block text-xs text-neurolink mr-2 border border-neurolink border-rounded rounded my-1 mx-1 px-1 py-1" to="/shop/tags/merch-bundles">Merch Bundles</nuxt-link>
        <nuxt-link class="inline-block text-xs text-neurolink mr-2 border border-neurolink border-rounded rounded my-1 mx-1 px-1 py-1" to="/shop/tags/black-metal-cassettes">Black Metal Cassettes</nuxt-link>
        <nuxt-link class="inline-block text-xs text-neurolink mr-2 border border-neurolink border-rounded rounded my-1 mx-1 px-1 py-1" to="/shop/tags/post-metal-cassettes">Post Metal Cassettes</nuxt-link>
        <nuxt-link class="inline-block text-xs text-neurolink mr-2 border border-neurolink border-rounded rounded my-1 mx-1 px-1 py-1" to="/shop/tags/post-metal-t-shirts">Post Metal T-Shirts</nuxt-link>
        <nuxt-link class="inline-block text-xs text-neurolink mr-2 border border-neurolink border-rounded rounded my-1 mx-1 px-1 py-1" to="/shop/tags/post-rock-cassettes">Post Rock Cassettes</nuxt-link>
        <nuxt-link class="inline-block text-xs text-neurolink mr-2 border border-neurolink border-rounded rounded my-1 mx-1 px-1 py-1" to="/shop/tags/post-rock-t-shirts">Post Rock T-Shirts</nuxt-link>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>
